import { render, staticRenderFns } from "./schoolResourcesList.vue?vue&type=template&id=3875f0e1"
import script from "./schoolResourcesList.vue?vue&type=script&lang=js"
export * from "./schoolResourcesList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports